import { SettingsGroupCard, SettingsHubPage, SettingsNavItem } from '../settings-shared';

export function SettingsDebugHubPage() {
  return (
    <SettingsHubPage title="Отладка">
      <SettingsGroupCard title="Инструменты">
        <SettingsNavItem
          title="Performance API"
          subTitle="Статистика кампаний, ZIP"
          to="/settings/debug/performance"
        />
        <SettingsNavItem
          title="Scheduler"
          subTitle="Cron: последний и следующий запуск"
          to="/settings/debug/scheduler"
        />
        <SettingsNavItem
          title="Ручные методы"
          subTitle="Выгрузка и сброс истории остатков"
          to="/settings/debug/manual"
          isLast
        />
      </SettingsGroupCard>
    </SettingsHubPage>
  );
}
